export default "__VITE_ASSET__DYQgfKob__"